import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

// Context
import { useToastContext } from 'context/toast-context';

// Store
import { useDispatch } from 'react-redux';
import { clearUserData, syncSession } from 'store/slices/userSlice';

// Utils
import bemify from 'utils/bemify';
import { supabase } from 'utils/supabase-client';

// Components
import Head from 'components/head';
import Toast from 'components/toast';

// Styles
import stylesModule from './styles.module.scss';


const styles = bemify(stylesModule);

const Layout = ({
  children = null,
  className = null,
  description = null,
  shareImage = null,
  title = null
}) => {
  const dispatch = useDispatch();

  const {
    description: toastDescription,
    icon: toastIcon,
    isOpen: isToastOpen,
    showToast
  } = useToastContext();

  let mainClassName = [styles.layout__main];

  if (className) mainClassName.push(className);

  mainClassName = mainClassName.join(' ');

  // Effects
  useEffect(() => {
    // Check the current session when the app initializes
    const checkSession = async () => {
      const { error } = await supabase.auth.getSession();

      if (error) {
        dispatch(clearUserData());
      } else {
        // If there's an active session, sync the session
        dispatch(syncSession());
      }
    };

    checkSession();

    // Listen for authentication state changes
    const { data: authListener } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session) {
        dispatch(syncSession());
      } else {
        dispatch(clearUserData());
      }
    });

    return () => {
      // Cleanup the listener when the component unmounts
      authListener.subscription?.unsubscribe();
    };
  }, [dispatch]);

  return (
    <div className={styles.layout}>
      <Head
        description={description}
        shareImage={shareImage}
        title={title}
      />
      <main className={styles.mainClassName}>
        {children}
        <Toast
          description={toastDescription}
          icon={toastIcon}
          isOpen={isToastOpen}
          showToast={showToast}
        />
      </main>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  className: PropTypes.string,
  description: PropTypes.string,
  shareImage: PropTypes.string,
  title: PropTypes.string
};

export default Layout;
